import React, { useState, memo } from 'react';
import { View, ScrollView } from 'react-native';
import {
  Card,
  Text,
  IconButton,
  IconLink,
  UserAvatar,
  Space,
  IconAdd,
} from '@redlink/components/atoms';
import {
  TextInput,
  DropDown,
  PreviewUserInfo,
  PreviewCategoryItem,
  PreviewLinkItem,
  RateView,
  FieldViewer,
  FormSection,
  Button,
  ColorInput,
  Checkbox,
} from '@redlink/components/molecules';
import { createUseStyle } from '@redlink/assets/styles';
import {
  PreviewCategoryList,
  PreviewGalleryPostCard,
  PreviewResumeItemsGroup,
  LinkItem,
  ThemeItem,
} from '@redlink/components/muscles';
import { Form } from '@redlink/components/organisms';
import { useLocale } from '@redlink/assets/locale';

const dropDownMockData = [
  { id: 1, value: 'All' },
  { id: 2, value: 'Logo' },
  { id: 3, value: 'illustration' },
];
const userTitle = 'arian.design';
const userSubtitle = 'Art director / Product designer';
const userAvatarImageUrl =
  'https://i.pinimg.com/originals/97/e4/2a/97e42a82fc7911961d3ca55f54d1372c.jpg';
const galleryItemMockData = {
  title: 'Tehran - Azadi Tower',
  subtitle: 'illustration',
  imageUrl:
    'https://instagram.fgyd4-1.fna.fbcdn.net/v/t51.2885-15/e35/83450492_555031765361334_4972054690675955551_n.jpg?_nc_ht=instagram.fgyd4-1.fna.fbcdn.net&_nc_cat=106&_nc_ohc=ClY8Y4eocJkAX_YpbCp&oh=f7fd1dc7e2b56b6f2b18ec66dd2514c8&oe=5F2E587C',
};
const resumeMockData = {
  experiences: [
    {
      title: 'Tapsi',
      subtitle: 'Head of design',
      period: 'khordad 76 - mordad 88',
    },
    {
      title: 'Cafebazaar',
      subtitle: 'UI/UX Designer',
      period: 'khordad 76 - mordad 88',
    },
  ],
};
const linkItemMockData = {
  // imageSource: require('@redlink/assets/images/dribbble.png'),
  title: 'dribbble',
  url: 'https://dribbble.com/arian',
  totalHit: 32,
};
const themeItemsMockData = [
  {
    title: 'Light',
    palette: {
      primary: '#f4354c',
      secondary: '#59c891',
      separator: '#dee0e2',
      title: '#000000',
      subtitle: '#6d6d6d',
      background: '#ffffff',
      cardBackground: '#f2f2f2',
    },
    isCurrent: false,
  },
  {
    title: 'Dark',
    palette: {
      primary: '#f4354c',
      secondary: '#59c891',
      separator: '#424462',
      title: '#ffffff',
      subtitle: '#f2f2f2',
      background: '#15161e',
      cardBackground: '#242535',
    },
    isCurrent: true,
  },
];

export const ComponentsPage = memo(() => {
  const { styles } = useStyle();
  const { dictionary } = useLocale();
  const [selectedDropDownValue, setSelectedDropDownValue] = useState(null);
  const [maskValue, setMaskValue] = useState({ raw: '', display: '' });
  const [maskValue2, setMaskValue2] = useState({ raw: '', display: '' });
  const [selectedCategoryIndex, setSelectedCategoryIndex] = useState(0);
  return (
    <ScrollView contentContainerStyle={styles.container}>
      <View>
        <Text>Components</Text>

        <ComponentContainer title="Checkbox">
          <Checkbox value={true} title="Option 1" />
          <Space />
          <Checkbox value={false} title="Option 2" />
        </ComponentContainer>

        <ComponentContainer title="ColorInput">
          <ColorInput title="Card Color" value="#f4354c" />
          <Space />
          <ColorInput title="Button Color" value="#59c891" />
        </ComponentContainer>

        <ComponentContainer title="ThemeItem" transparent>
          <View style={styles.themeItemsContainer}>
            <ThemeItem item={themeItemsMockData[0]} style={styles.themeCard} />
            <Space />
            <ThemeItem item={themeItemsMockData[1]} style={styles.themeCard} />
          </View>
        </ComponentContainer>

        <ComponentContainer title="TextInput">
          <TextInput
            editable={false}
            style={styles.textInput}
            title="Short Link"
            value="redl.ink/gallery023122"
          />
          <TextInput
            style={styles.textInput}
            title="Title"
            value="This is a text."
          />
          <TextInput
            style={styles.textInput}
            title="Short Link"
            prefix="redl.ink/gallery"
            value="Ari-023122"
          />
          <TextInput
            style={styles.textInput}
            title="Link"
            placeholder="ex: instagram.com/ar236ft"
          />
          <TextInput style={styles.textInput} title="Type" />
        </ComponentContainer>

        <ComponentContainer title="LinkItem" transparent>
          <LinkItem item={linkItemMockData} />
        </ComponentContainer>

        <ComponentContainer title="Button">
          <Button title="Primary" variant="primary" />
          <Space />
          <Button title="Secondary" variant="secondary" />
          <Space />
          <Button title="Button+Icon" variant="primary" icon={<IconAdd />} />
        </ComponentContainer>

        <ComponentContainer title="Form" transparent>
          <Form
            style={styles.formContainer}
            actions={[
              {
                title: 'Action1',
                variant: 'primary',
                onPress: () => console.log('Action1'),
              },
              { title: 'Action2', variant: 'secondary' },
            ]}
          >
            <FormSection title="Profile">
              <TextInput
                style={styles.textInput}
                title="Title"
                value="This is a text."
              />
              <TextInput
                style={styles.textInput}
                title="Short Link"
                prefix="redl.ink/gallery"
                value="Ari-023122"
              />
              <TextInput style={styles.textInput} title="Type" />
            </FormSection>
            <FormSection title="Setting">
              <TextInput
                style={styles.textInput}
                title="Link"
                placeholder="ex: instagram.com/ar236ft"
              />
            </FormSection>
          </Form>
        </ComponentContainer>

        <ComponentContainer title="FormSection">
          <FormSection title="Profile">
            <FieldViewer title="Name" value="Arian" />
            <Space size={16} />
            <FieldViewer title="Bio" value="Product designer" />
          </FormSection>
        </ComponentContainer>

        <ComponentContainer title="FieldViewer">
          <FieldViewer title="Name" value="Arian" />
          <Space size={16} />
          <FieldViewer title="Bio" value="Product designer" />
        </ComponentContainer>

        <ComponentContainer title="RateView">
          <RateView value={3} starSize={25} />
          <RateView value={1} starSize={15} />
          <RateView value={5} starSize={10} />
        </ComponentContainer>

        {/* <ComponentContainer title="PreviewResumeItemsGroup">
          <PreviewResumeItemsGroup
            title="Experience"
            data={resumeMockData.experiences}
            ItemComponent={(props) => <PreviewResumeItem {...props} />}
          />
        </ComponentContainer>

        <ComponentContainer title="PreviewResumeItem">
          <PreviewResumeItem item={resumeMockData.experiences[0]} />
        </ComponentContainer> */}

        <ComponentContainer title="PreviewLinkItem">
          <PreviewLinkItem
            // imageSource={require('@redlink/assets/images/dribbble.png')}
            title="dribbble"
            externalUrl="http://dribbble.com"
          />
        </ComponentContainer>

        <ComponentContainer title="GalleryPostCard">
          <PreviewGalleryPostCard
            item={galleryItemMockData}
            style={styles.galleryCard}
          />
        </ComponentContainer>

        <ComponentContainer title="PreviewCateogoryList">
          <PreviewCategoryList
            data={dropDownMockData}
            selectedIndex={selectedCategoryIndex}
            onChange={(item, index) => setSelectedCategoryIndex(index)}
          />
        </ComponentContainer>

        <ComponentContainer title="PreviewCateogoryItem">
          <View style={styles.categoryItemContainer}>
            <PreviewCategoryItem item={dropDownMockData[0]} />
            <PreviewCategoryItem item={dropDownMockData[1]} isFocused />
            <PreviewCategoryItem item={dropDownMockData[2]} />
          </View>
        </ComponentContainer>

        <ComponentContainer title="PreviewUserInfo">
          <PreviewUserInfo
            imageSource={{ uri: userAvatarImageUrl }}
            title={userTitle}
            subtitle={userSubtitle}
          />
        </ComponentContainer>

        <ComponentContainer title="UserAvatar">
          <UserAvatar source={{ uri: userAvatarImageUrl }} />
        </ComponentContainer>

        <ComponentContainer title="Button">
          <IconButton>
            <IconLink />
          </IconButton>
        </ComponentContainer>

        <ComponentContainer title="DropDown">
          <DropDown
            style={styles.textInput}
            title="Category"
            data={dropDownMockData}
            nullable
            value={selectedDropDownValue}
            onChange={(item, index) => setSelectedDropDownValue(item)}
          />
          <DropDown
            style={styles.textInput}
            title="Nullable Category"
            data={dropDownMockData}
            nullable={false}
            value={selectedDropDownValue}
            onChange={(item, index) => setSelectedDropDownValue(item)}
          />
        </ComponentContainer>

        <ComponentContainer title="MaskTextInput">
          <TextInput
            style={styles.textInput}
            title="Mask"
            placeholder="1399/04"
            mask={{
              type: 'custome',
              pattern: '9999/99',
              getRawValue: (value) => value.replace(/[/]+/g, ''),
            }}
            value={maskValue.display}
            onChangeText={(raw, display) => setMaskValue({ raw, display })}
          />
          <TextInput
            style={styles.textInput}
            placeholder="238,000"
            title="Price"
            postfix="Toman"
            mask={{
              type: 'money',
            }}
            value={maskValue2.display}
            onChangeText={(raw, display) => setMaskValue2({ raw, display })}
          />
        </ComponentContainer>
      </View>
    </ScrollView>
  );
});

const ComponentContainer = memo(({ title, children, transparent = false }) => {
  const { styles } = useStyle();
  return (
    <Card
      style={[styles.card, transparent && { backgroundColor: 'transparent' }]}
    >
      <Text>{title}</Text>
      <View style={styles.componentContainer}>{children}</View>
    </Card>
  );
});

const useStyle = createUseStyle(({ colors, size }) => ({
  container: {
    paddingHorizontal: size.screenHorizontalPadding,
    paddingVertical: size.screenVerticalPadding,
  },
  card: {
    minHeight: 112,
    marginTop: 8,
  },
  textInput: {
    marginBottom: 20,
  },
  componentContainer: {
    paddingTop: 20,
  },
  categoryItemContainer: {
    flexDirection: 'row',
  },
  galleryCard: {
    width: 312,
  },
  formContainer: {
    width: 432,
  },
  themeItemsContainer: {
    flexDirection: 'row',
  },
  themeCard: {
    width: 208,
  },
}));
